import { useState, useEffect } from 'react';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [activeModal, setActiveModal] = useState<number | null>(null);
  const [activeVideo, setActiveVideo] = useState<number | null>(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (activeModal !== null || activeVideo !== null || mobileMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [activeModal, activeVideo, mobileMenu]);

  const featureModals = [
    {
      title: 'Разделы и подпункты',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20project%20management%20interface%20showing%20hierarchical%20folder%20tree%20structure%20with%20nested%20sections%20and%20subsections%20on%20a%20light%20gray%20background%20modern%20flat%20design%20UI%20mockup%20with%20soft%20shadows%20and%20rounded%20corners%20professional%20dashboard%20layout&width=800&height=450&seq=feat1&orientation=landscape',
      description: 'Организуйте проект в виде дерева разделов с неограниченной вложенностью. Каждый раздел может содержать подразделы, задачи и собственные настройки полей. Перетаскивайте элементы между разделами, сворачивайте и разворачивайте ветки для удобной навигации по большим проектам.',
      details: [
        'Неограниченная глубина вложенности',
        'Drag & drop для перемещения элементов',
        'Сворачивание и разворачивание веток',
        'Индивидуальные настройки для каждого раздела',
      ],
    },
    {
      title: 'Кастомные поля',
      image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20UI%20form%20builder%20interface%20with%20custom%20fields%20showing%20dropdown%20selects%20number%20inputs%20checkboxes%20and%20text%20fields%20on%20white%20background%20minimal%20flat%20design%20with%20soft%20green%20accent%20colors%20professional%20web%20application%20mockup&width=800&height=450&seq=feat2&orientation=landscape',
      description: 'Добавляйте к задачам любые дополнительные поля, чтобы адаптировать систему под ваши процессы. Поддерживаются числовые поля (integer), выпадающие списки (select), переключатели (да/нет) и текстовые поля. Каждое поле можно сделать обязательным и задать значение по умолчанию.',
      details: [
        'Integer — числовые значения (бюджет, приоритет)',
        'Select — выпадающие списки с вариантами',
        'Да/Нет — переключатели и чекбоксы',
        'Текст — произвольные текстовые поля',
      ],
    },
    {
      title: 'Время и длительность',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20time%20tracking%20dashboard%20interface%20with%20timeline%20bars%20duration%20counters%20and%20progress%20indicators%20on%20light%20background%20minimal%20flat%20design%20with%20green%20accent%20elements%20professional%20project%20management%20tool%20UI%20mockup&width=800&height=450&seq=feat3&orientation=landscape',
      description: 'Устанавливайте время начала и окончания для каждой задачи, отслеживайте длительность выполнения и контролируйте сроки. Система автоматически рассчитывает оставшееся время и подсвечивает просроченные задачи.',
      details: [
        'Дата начала и окончания задачи',
        'Автоматический расчёт длительности',
        'Подсветка просроченных задач',
        'Контроль сроков с точностью до минуты',
      ],
    },
    {
      title: 'Хештеги и фильтры',
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20search%20and%20filter%20interface%20with%20colorful%20hashtag%20labels%20tags%20and%20filter%20dropdowns%20on%20white%20background%20clean%20flat%20UI%20design%20with%20soft%20green%20and%20gray%20tones%20professional%20task%20management%20filtering%20system%20mockup&width=800&height=450&seq=feat4&orientation=landscape',
      description: 'Маркируйте задачи хештегами для быстрой категоризации и используйте мощную систему фильтров для мгновенного поиска. Комбинируйте фильтры по полям, хештегам, датам и статусам для точной выборки нужных задач.',
      details: [
        'Произвольные хештеги для задач',
        'Комбинированные фильтры по нескольким параметрам',
        'Мгновенный поиск по всему проекту',
        'Сохранение часто используемых фильтров',
      ],
    },
    {
      title: 'Календарь проекта',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20project%20calendar%20view%20interface%20with%20task%20cards%20placed%20on%20monthly%20grid%20showing%20deadlines%20and%20milestones%20on%20light%20background%20minimal%20flat%20design%20with%20green%20accent%20highlights%20professional%20scheduling%20dashboard%20UI%20mockup&width=800&height=450&seq=feat5&orientation=landscape',
      description: 'Визуализируйте все задачи и дедлайны в едином календаре. Переключайтесь между видами: день, неделя, месяц. Перетаскивайте задачи прямо в календаре для быстрого перепланирования.',
      details: [
        'Виды: день, неделя, месяц',
        'Drag & drop задач в календаре',
        'Цветовая маркировка по разделам',
        'Быстрое создание задач из календаря',
      ],
    },
    {
      title: 'Единый источник данных',
      image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20data%20synchronization%20dashboard%20showing%20connected%20devices%20and%20real%20time%20sync%20indicators%20with%20cloud%20storage%20icon%20on%20light%20background%20minimal%20flat%20UI%20design%20with%20green%20accents%20professional%20collaboration%20platform%20mockup&width=800&height=450&seq=feat6&orientation=landscape',
      description: 'Вся информация о проектах хранится централизованно и доступна в реальном времени. Забудьте о разрозненных таблицах и документах — PITIP становится единым источником правды для всей команды.',
      details: [
        'Централизованное хранение всех данных',
        'Синхронизация в реальном времени',
        'Доступ с любого устройства',
        'История изменений и версионирование',
      ],
    },
  ];

  const videoTutorials = [
    {
      title: 'Создание первого проекта',
      description: 'Пошаговое руководство по созданию проекта, настройке разделов и добавлению первых задач в PITIP.',
      duration: '4:32',
      tag: 'Начало работы',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20dark%20themed%20project%20management%20dashboard%20interface%20showing%20project%20creation%20wizard%20with%20form%20fields%20and%20folder%20structure%20on%20dark%20charcoal%20background%20with%20subtle%20green%20accent%20highlights%20minimalist%20flat%20UI%20design%20professional%20software%20tutorial%20screenshot&width=640&height=360&seq=vid1&orientation=landscape',
    },
    {
      title: 'Настройка кастомных полей',
      description: 'Как добавить числовые поля, выпадающие списки и чекбоксы к задачам для полной кастомизации.',
      duration: '6:15',
      tag: 'Поля',
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20UI%20settings%20panel%20showing%20custom%20field%20configuration%20with%20dropdown%20menus%20toggle%20switches%20and%20input%20fields%20on%20dark%20gray%20interface%20with%20green%20checkmarks%20clean%20flat%20design%20professional%20web%20application%20tutorial%20screenshot&width=640&height=360&seq=vid2&orientation=landscape',
    },
    {
      title: 'Работа с разделами',
      description: 'Организация проекта в виде дерева: создание вложенных разделов, перемещение и сортировка элементов.',
      duration: '5:48',
      tag: 'Структура',
      image: 'https://readdy.ai/api/search-image?query=Clean%20dark%20themed%20sidebar%20navigation%20showing%20hierarchical%20tree%20structure%20with%20expandable%20folders%20and%20nested%20items%20drag%20and%20drop%20indicators%20on%20charcoal%20background%20with%20subtle%20green%20highlights%20minimalist%20flat%20UI%20professional%20tutorial%20screenshot&width=640&height=360&seq=vid3&orientation=landscape',
    },
    {
      title: 'Хештеги и фильтрация',
      description: 'Маркировка задач хештегами и использование мощных фильтров для мгновенного поиска нужной информации.',
      duration: '3:56',
      tag: 'Фильтры',
      image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20filter%20panel%20interface%20with%20colorful%20tag%20labels%20search%20bar%20and%20filter%20dropdown%20options%20showing%20task%20list%20results%20on%20dark%20background%20with%20green%20accent%20badges%20minimalist%20flat%20design%20professional%20software%20tutorial%20screenshot&width=640&height=360&seq=vid4&orientation=landscape',
    },
    {
      title: 'Календарь и дедлайны',
      description: 'Визуализация задач в календаре, установка сроков и отслеживание прогресса по датам.',
      duration: '5:10',
      tag: 'Календарь',
      image: 'https://readdy.ai/api/search-image?query=Modern%20dark%20themed%20calendar%20view%20interface%20showing%20monthly%20grid%20with%20colored%20task%20cards%20and%20deadline%20markers%20on%20charcoal%20background%20with%20green%20accent%20highlights%20clean%20minimalist%20flat%20UI%20design%20professional%20project%20management%20tutorial%20screenshot&width=640&height=360&seq=vid5&orientation=landscape',
    },
    {
      title: 'Экспорт и отчёты',
      description: 'Выгрузка данных проекта в CSV и JSON, формирование отчётов и аналитика по задачам.',
      duration: '4:03',
      tag: 'Экспорт',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20data%20export%20interface%20showing%20file%20format%20selection%20CSV%20JSON%20options%20with%20progress%20bar%20and%20download%20buttons%20on%20dark%20gray%20background%20with%20green%20accent%20elements%20minimalist%20flat%20UI%20design%20professional%20software%20tutorial%20screenshot&width=640&height=360&seq=vid6&orientation=landscape',
    },
  ];

  const featureIcons = ['ri-folder-line', 'ri-settings-3-line', 'ri-time-line', 'ri-price-tag-3-line', 'ri-calendar-line', 'ri-database-2-line'];

  return (
    <div className="min-h-screen bg-[#FAFAFA]" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
      {/* Feature Modal */}
      {activeModal !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4" onClick={() => setActiveModal(null)}>
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
          <div className="relative bg-white rounded-2xl max-w-[720px] w-full max-h-[90vh] overflow-y-auto shadow-[0_24px_80px_rgba(0,0,0,0.15)] animate-[modalIn_0.25s_ease-out]" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-black/5 hover:bg-black/10 transition-colors duration-200 cursor-pointer">
              <i className="ri-close-line text-lg text-[#1A1D21]"></i>
            </button>
            <div className="w-full h-[240px] sm:h-[360px] bg-[#F5F5F5] rounded-t-2xl overflow-hidden">
              <img src={featureModals[activeModal].image} alt={featureModals[activeModal].title} className="w-full h-full object-cover object-top" />
            </div>
            <div className="p-6 sm:p-9">
              <h3 className="text-xl sm:text-2xl font-bold text-[#1A1D21] mb-4">{featureModals[activeModal].title}</h3>
              <p className="text-sm sm:text-[15px] text-[#6B7280] leading-[1.75] mb-6">{featureModals[activeModal].description}</p>
              <div className="space-y-3">
                {featureModals[activeModal].details.map((detail, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#2ED596] text-base"></i>
                    </div>
                    <span className="text-sm sm:text-[15px] text-[#4B5563] leading-[1.6]">{detail}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Video Modal */}
      {activeVideo !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4" onClick={() => setActiveVideo(null)}>
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
          <div className="relative bg-[#1A1D21] rounded-2xl max-w-[860px] w-full overflow-hidden shadow-[0_24px_80px_rgba(0,0,0,0.4)] animate-[modalIn_0.25s_ease-out]" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActiveVideo(null)} className="absolute top-4 right-4 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200 cursor-pointer">
              <i className="ri-close-line text-lg text-white"></i>
            </button>
            <div className="w-full aspect-video bg-[#111] flex flex-col items-center justify-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white/10 flex items-center justify-center mb-5">
                <i className="ri-play-fill text-white text-3xl sm:text-4xl ml-1"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-white mb-2 px-4 text-center">{videoTutorials[activeVideo].title}</h3>
              <p className="text-sm text-white/50">{videoTutorials[activeVideo].duration} · {videoTutorials[activeVideo].tag}</p>
            </div>
            <div className="p-5 sm:p-7">
              <p className="text-sm sm:text-[15px] text-white/60 leading-[1.7]">{videoTutorials[activeVideo].description}</p>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Menu */}
      {mobileMenu && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setMobileMenu(false)}></div>
          <div className="absolute top-0 right-0 w-[280px] h-full bg-[#1A1D21] p-6 flex flex-col animate-[modalIn_0.2s_ease-out]">
            <button onClick={() => setMobileMenu(false)} className="self-end w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200 cursor-pointer">
              <i className="ri-close-line text-lg text-white"></i>
            </button>
            <nav className="flex flex-col gap-5">
              <a href="#features" onClick={() => setMobileMenu(false)} className="text-[15px] text-white/70 hover:text-white transition-colors cursor-pointer">Возможности</a>
              <a href="#tutorials" onClick={() => setMobileMenu(false)} className="text-[15px] text-white/70 hover:text-white transition-colors cursor-pointer">Инструкции</a>
              <a href="#pricing" onClick={() => setMobileMenu(false)} className="text-[15px] text-white/70 hover:text-white transition-colors cursor-pointer">Тарифы</a>
              <a href="#faq" onClick={() => setMobileMenu(false)} className="text-[15px] text-white/70 hover:text-white transition-colors cursor-pointer">FAQ</a>
            </nav>
            <div className="mt-auto flex flex-col gap-3">
              <button className="w-full bg-white/10 border border-white/15 text-white text-sm py-3 rounded-lg font-medium whitespace-nowrap cursor-pointer">Войти</button>
              <button className="w-full bg-[#2ED596] text-[#1A1D21] text-sm py-3 rounded-lg font-semibold whitespace-nowrap cursor-pointer">Попробовать</button>
            </div>
          </div>
        </div>
      )}

      {/* Sticky Nav */}
      <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-[0_1px_12px_rgba(0,0,0,0.06)]' : 'bg-transparent'}`}>
        <div className="max-w-[1280px] mx-auto px-5 sm:px-6 flex items-center justify-between h-[68px]">
          <div className="flex items-center gap-2.5">
            <img src="https://static.readdy.ai/image/a7bae0ab6e910543915ac404c3477688/68a994a495d65f03a0ceb04460b10eaa.png" alt="PITIP Logo" className="w-9 h-9 object-contain" />
            <h1><a href="/" className={`text-xl font-bold tracking-tight transition-colors ${scrolled ? 'text-[#1A1D21]' : 'text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.3)]'}`}>PITIP</a></h1>
          </div>
          <div className="hidden lg:flex items-center gap-6">
            <a href="#features" className={`text-[13px] font-medium transition-colors duration-300 cursor-pointer ${scrolled ? 'text-[#6B7280] hover:text-[#1A1D21]' : 'text-white/75 hover:text-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.2)]'}`}>Возможности</a>
            <a href="#tutorials" className={`text-[13px] font-medium transition-colors duration-300 cursor-pointer ${scrolled ? 'text-[#6B7280] hover:text-[#1A1D21]' : 'text-white/75 hover:text-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.2)]'}`}>Инструкции</a>
            <a href="#pricing" className={`text-[13px] font-medium transition-colors duration-300 cursor-pointer ${scrolled ? 'text-[#6B7280] hover:text-[#1A1D21]' : 'text-white/75 hover:text-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.2)]'}`}>Тарифы</a>
            <a href="#faq" className={`text-[13px] font-medium transition-colors duration-300 cursor-pointer ${scrolled ? 'text-[#6B7280] hover:text-[#1A1D21]' : 'text-white/75 hover:text-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.2)]'}`}>FAQ</a>
          </div>
          <div className="hidden lg:flex items-center gap-3">
            <button className={`text-[13px] px-5 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer border ${scrolled ? 'border-[#E0E0E0] text-[#1A1D21] hover:bg-[#F5F5F5]' : 'border-white/25 bg-white/10 backdrop-blur-sm text-white hover:bg-white/20'}`}>Войти</button>
            <button className="bg-[#2ED596] text-[#1A1D21] text-[13px] px-5 py-2 rounded-lg font-semibold hover:bg-[#3BE0A3] transition-all duration-300 whitespace-nowrap cursor-pointer">Попробовать</button>
          </div>
          <button onClick={() => setMobileMenu(true)} className={`lg:hidden w-9 h-9 flex items-center justify-center cursor-pointer ${scrolled ? 'text-[#1A1D21]' : 'text-white'}`}>
            <i className="ri-menu-line text-xl"></i>
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative overflow-hidden min-h-[100vh]">
        <div className="absolute inset-0" style={{ transform: `translateY(${scrollY * 0.3}px)` }}>
          <img src="https://static.readdy.ai/image/a7bae0ab6e910543915ac404c3477688/acce5d71e6696a3220b301f745601915.png" alt="" className="w-full h-full object-cover object-center" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70"></div>

        <div className="relative z-10 max-w-[1280px] mx-auto px-5 sm:px-6 pt-[130px] sm:pt-[160px] pb-0">
          <div className="text-center max-w-[860px] mx-auto mb-10 sm:mb-14 w-full">
            <div className="inline-block bg-white/10 backdrop-blur-md text-[#2ED596] text-xs sm:text-sm px-4 sm:px-5 py-2 rounded-full mb-6 sm:mb-8 font-medium border border-white/15">
              Гибкая система управления
            </div>
            <h2 className="text-[36px] sm:text-[48px] lg:text-[60px] leading-[1.1] font-bold text-white mb-5 sm:mb-6 tracking-tight drop-shadow-[0_2px_16px_rgba(0,0,0,0.4)]">
              Управление проектами без&nbsp;ограничений
            </h2>
            <p className="text-base sm:text-lg text-white/70 leading-[1.65] max-w-[600px] mx-auto mb-8 sm:mb-10 px-2 drop-shadow-[0_1px_6px_rgba(0,0,0,0.2)]">
              Веб-платформа с гибкой структурой разделов, кастомными полями и мощными инструментами для задач любой сложности
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-14 sm:mb-20 w-full">
              <button className="w-full sm:w-auto bg-[#2ED596] text-[#1A1D21] text-[15px] px-8 sm:px-10 py-3.5 sm:py-4 rounded-xl font-semibold shadow-[0_4px_24px_rgba(46,213,150,0.3)] hover:bg-[#3BE0A3] hover:shadow-[0_6px_32px_rgba(46,213,150,0.4)] transition-all duration-300 whitespace-nowrap cursor-pointer">
                регистрация
              </button>
              <button className="w-full sm:w-auto bg-white/10 backdrop-blur-md border border-white/20 text-white text-[15px] px-8 sm:px-10 py-3.5 sm:py-4 rounded-xl font-semibold hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer">
                Войти в аккаунт
              </button>
            </div>
          </div>

          {/* Screenshot */}
          <div className="max-w-[1200px] mx-auto" style={{ transform: `translateY(${scrollY * -0.08}px)` }}>
            <div className="rounded-t-[16px] sm:rounded-t-[20px] shadow-[0_-8px_80px_rgba(0,0,0,0.35)] overflow-hidden bg-[#1a1a1a]">
              <div className="bg-[#2a2a2a] px-4 py-2.5 sm:py-3 flex items-center gap-2">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#ff5f57]"></div>
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#febc2e]"></div>
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#28c840]"></div>
                <div className="ml-3 sm:ml-4 bg-[#1a1a1a] rounded-md px-3 sm:px-4 py-1 text-[11px] sm:text-xs text-white/40 flex-1 max-w-[300px] sm:max-w-[400px]">pitip.app</div>
              </div>
              <img src="https://static.readdy.ai/image/a7bae0ab6e910543915ac404c3477688/fedcdbdcd6c2d6ca408e82808bae163c.png" alt="Интерфейс PITIP - система управления проектами и задачами" className="w-full object-cover object-top" style={{ maxHeight: '560px' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section id="features" className="bg-white py-20 sm:py-[120px] lg:py-[140px] px-5 sm:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-[28px] sm:text-[36px] lg:text-[44px] font-bold text-[#1A1D21] text-center mb-3 sm:mb-4 tracking-tight">Что умеет PITIP</h2>
          <p className="text-sm sm:text-base text-[#6B7280] text-center mb-12 sm:mb-16 lg:mb-20 max-w-[520px] mx-auto">Полный набор инструментов для организации проектов любой сложности</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-7">
            {featureModals.map((feature, index) => (
              <div key={index} onClick={() => setActiveModal(index)} className="bg-[#FAFAFA] border border-[#EAEAEA] rounded-2xl p-7 sm:p-8 lg:p-9 hover:shadow-[0_8px_32px_rgba(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-300 cursor-pointer group">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-[#1A1D21] to-[#3A3D45] flex items-center justify-center mb-5 sm:mb-6">
                  <i className={`${featureIcons[index]} text-[#2ED596] text-lg sm:text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-[#1A1D21] mb-2.5 sm:mb-3">{feature.title}</h3>
                <p className="text-[14px] text-[#6B7280] leading-[1.7] mb-4">{feature.description.slice(0, 120)}...</p>
                <span className="text-[13px] text-[#2ED596] font-medium group-hover:underline flex items-center gap-1.5">
                  Подробнее <i className="ri-arrow-right-s-line text-base"></i>
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* In Development Section */}
      <section className="bg-[#F5F5F5] py-20 sm:py-[100px] lg:py-[120px] px-5 sm:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-[28px] sm:text-[36px] lg:text-[40px] font-bold text-[#1A1D21] text-center mb-3 sm:mb-4 tracking-tight">Скоро в PITIP</h2>
          <p className="text-sm sm:text-base text-[#6B7280] text-center mb-12 sm:mb-16">Функции, которые мы активно разрабатываем</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-7">
            {[
              { icon: 'ri-user-add-line', title: 'Назначение пользователей', desc: 'Добавляйте участников команды в проект и назначайте их на конкретные задачи с распределением ролей и прав доступа' },
              { icon: 'ri-file-list-3-line', title: 'Внешние формы сбора данных', desc: 'Создавайте публичные формы для сбора заявок, обращений или данных извне, которые автоматически попадают в ваш проект' },
              { icon: 'ri-share-line', title: 'Публикация и «поделиться»', desc: 'Делитесь проектами или отдельными разделами с внешними пользователями через защищённые ссылки с настройкой уровня доступа' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 sm:p-8 lg:p-9 relative border border-[#EAEAEA]">
                <div className="absolute top-7 right-7 sm:top-8 sm:right-8 lg:top-9 lg:right-9">
                  <span className="text-[11px] bg-[#1A1D21] text-white px-3 py-1.5 rounded-full font-medium whitespace-nowrap">В разработке</span>
                </div>
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-[#1A1D21] to-[#3A3D45] flex items-center justify-center mb-5 sm:mb-6 opacity-50">
                  <i className={`${item.icon} text-[#2ED596] text-lg sm:text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-[#1A1D21] mb-2.5 sm:mb-3">{item.title}</h3>
                <p className="text-[14px] text-[#6B7280] leading-[1.7]">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Tutorials Section */}
      <section id="tutorials" className="bg-white py-20 sm:py-[120px] lg:py-[140px] px-5 sm:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-12 sm:mb-16 gap-4">
            <div>
              <span className="text-xs font-semibold text-[#2ED596] uppercase tracking-wider">Видео-инструкции</span>
              <h2 className="text-[28px] sm:text-[36px] lg:text-[44px] font-bold text-[#1A1D21] mt-2 leading-[1.1] tracking-tight">Смотрите и учитесь</h2>
            </div>
            <p className="text-[14px] text-[#6B7280] leading-[1.7] max-w-[400px] sm:text-right">Короткие видеоролики, которые помогут быстро освоить все возможности платформы</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-7">
            {videoTutorials.map((video, index) => (
              <div key={index} onClick={() => setActiveVideo(index)} className="group bg-[#FAFAFA] border border-[#EAEAEA] rounded-2xl overflow-hidden hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 cursor-pointer">
                <div className="relative w-full h-[180px] sm:h-[200px] overflow-hidden">
                  <img src={video.image} alt={video.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-[0_4px_20px_rgba(0,0,0,0.15)] group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-[#1A1D21] text-xl sm:text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 bg-black/70 backdrop-blur-sm text-white text-[11px] font-medium px-2.5 py-1 rounded-md">{video.duration}</div>
                </div>
                <div className="p-5 sm:p-6">
                  <span className="inline-block text-[11px] font-semibold text-[#1A1D21] bg-[#2ED596]/15 px-3 py-1 rounded-full mb-3">{video.tag}</span>
                  <h3 className="text-base sm:text-lg font-semibold text-[#1A1D21] mb-2 leading-snug">{video.title}</h3>
                  <p className="text-[13px] sm:text-[14px] text-[#6B7280] leading-[1.65]">{video.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="bg-[#FAFAFA] py-20 sm:py-[120px] lg:py-[140px] px-5 sm:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-[28px] sm:text-[36px] lg:text-[44px] font-bold text-[#1A1D21] text-center mb-12 sm:mb-16 lg:mb-20 tracking-tight">Почему PITIP</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-x-10 sm:gap-y-12 max-w-[1000px] mx-auto">
            {[
              { title: 'Гибкость структуры', desc: 'Настраивайте проект под любые процессы: от простых списков до сложных многоуровневых структур с десятками кастомных полей' },
              { title: 'Скорость работы', desc: 'Быстрый интерфейс, мгновенный поиск и фильтрация, горячие клавиши — работайте эффективно даже с тысячами задач' },
              { title: 'Единый источник правды', desc: 'Забудьте о разрозненных таблицах и документах — вся информация о проектах в одном месте, всегда актуальна и доступна' },
              { title: 'Масштабируемость', desc: 'Начните с одного проекта и масштабируйте до сотен проектов и тысяч задач без потери производительности' },
            ].map((b, i) => (
              <div key={i} className="flex items-start">
                <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-[#1A1D21]/5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#2ED596] text-lg sm:text-xl"></i>
                </div>
                <div className="ml-4 sm:ml-5">
                  <h3 className="text-base sm:text-lg font-semibold text-[#1A1D21] mb-2">{b.title}</h3>
                  <p className="text-[14px] text-[#6B7280] leading-[1.6]">{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="bg-white py-20 sm:py-[120px] lg:py-[140px] px-5 sm:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-[28px] sm:text-[36px] lg:text-[44px] font-bold text-[#1A1D21] text-center mb-3 sm:mb-4 tracking-tight">Тарифы</h2>
          <p className="text-sm sm:text-base text-[#6B7280] text-center mb-12 sm:mb-16 lg:mb-20 max-w-[520px] mx-auto">Начните бесплатно — перейдите на Pro, когда будете готовы</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 max-w-[820px] mx-auto">
            {/* Free Plan */}
            <div className="bg-[#FAFAFA] border border-[#EAEAEA] rounded-2xl p-7 sm:p-8 lg:p-10 flex flex-col">
              <div className="mb-6 sm:mb-8">
                <span className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider">Бесплатный</span>
                <div className="mt-3 sm:mt-4 flex items-end gap-1">
                  <span className="text-[40px] sm:text-[48px] lg:text-[52px] font-bold text-[#1A1D21] leading-none tracking-tight">0 ₽</span>
                  <span className="text-[14px] text-[#6B7280] mb-2">/ навсегда</span>
                </div>
                <p className="text-[14px] text-[#6B7280] mt-3 leading-[1.6]">Для личных проектов и знакомства с платформой</p>
              </div>
              <div className="space-y-3.5 sm:space-y-4 mb-8 sm:mb-10 flex-1">
                {['До 3 проектов', 'До 100 задач на проект', 'Разделы и подпункты', 'Базовые кастомные поля', 'Хештеги и фильтры', 'Календарь проекта'].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0"><i className="ri-check-line text-[#2ED596] text-base"></i></div>
                    <span className="text-[14px] text-[#4B5563]">{item}</span>
                  </div>
                ))}
              </div>
              <button className="w-full bg-[#1A1D21]/5 text-[#1A1D21] text-[14px] py-3.5 rounded-xl font-semibold hover:bg-[#1A1D21]/10 transition-all duration-300 whitespace-nowrap cursor-pointer">Начать бесплатно</button>
            </div>

            {/* Pro Plan */}
            <div className="bg-gradient-to-br from-[#1A1D21] via-[#252830] to-[#2E3039] rounded-2xl p-7 sm:p-8 lg:p-10 flex flex-col relative overflow-hidden">
              <div className="absolute top-0 right-0 w-[200px] h-[200px] bg-[radial-gradient(circle,rgba(46,213,150,0.12),transparent_70%)]"></div>
              <div className="relative z-10 mb-6 sm:mb-8">
                <div className="flex items-center gap-3">
                  <span className="text-xs font-semibold text-[#2ED596] uppercase tracking-wider">Pro</span>
                  <span className="text-[11px] bg-[#2ED596]/15 text-[#2ED596] px-2.5 py-1 rounded-full font-medium">Популярный</span>
                </div>
                <div className="mt-3 sm:mt-4 flex items-end gap-1">
                  <span className="text-[40px] sm:text-[48px] lg:text-[52px] font-bold text-white leading-none tracking-tight">490 ₽</span>
                  <span className="text-[14px] text-white/50 mb-2">/ месяц</span>
                </div>
                <p className="text-[14px] text-white/50 mt-3 leading-[1.6]">Для команд и серьёзных проектов без ограничений</p>
              </div>
              <div className="relative z-10 space-y-3.5 sm:space-y-4 mb-8 sm:mb-10 flex-1">
                {['Неограниченные проекты', 'Неограниченные задачи', 'Все типы кастомных полей', 'Время и длительность задач', 'Приоритетная поддержка', 'Экспорт в CSV и JSON', 'Назначение пользователей', 'Внешние формы сбора данных'].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0"><i className="ri-check-line text-[#2ED596] text-base"></i></div>
                    <span className="text-[14px] text-white/80">{item}</span>
                  </div>
                ))}
              </div>
              <button className="relative z-10 w-full bg-[#2ED596] text-[#1A1D21] text-[14px] py-3.5 rounded-xl font-semibold shadow-[0_4px_20px_rgba(46,213,150,0.25)] hover:bg-[#3BE0A3] hover:shadow-[0_6px_28px_rgba(46,213,150,0.35)] transition-all duration-300 whitespace-nowrap cursor-pointer">Перейти на Pro</button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="bg-white py-20 sm:py-[100px] lg:py-[120px] px-5 sm:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-[28px] sm:text-[36px] lg:text-[40px] font-bold text-[#1A1D21] text-center mb-10 sm:mb-16 tracking-tight">Частые вопросы</h2>

          <div className="max-w-[800px] mx-auto space-y-3 sm:space-y-4">
            {[
              { q: 'Что такое кастомные поля и зачем они нужны?', a: 'Кастомные поля позволяют добавлять к задачам любые дополнительные данные: числовые значения (бюджет, приоритет), выпадающие списки (статус, категория), чекбоксы (да/нет) и текстовые поля. Это делает PITIP универсальным инструментом для любых процессов — от разработки ПО до управления продажами.' },
              { q: 'Можно ли работать в команде?', a: 'Да, функция назначения пользователей на задачи находится в активной разработке. Скоро вы сможете добавлять участников команды, распределять задачи между ними и настраивать права доступа к разным разделам проекта.' },
              { q: 'Как экспортировать данные из PITIP?', a: 'PITIP поддерживает экспорт проектов и задач в популярные форматы (CSV, JSON). Вы всегда сохраняете полный контроль над своими данными и можете выгрузить их для анализа или миграции в другие системы.' },
              { q: 'Есть ли мобильная версия?', a: 'PITIP — это веб-приложение с адаптивным дизайном, которое отлично работает в браузере на любых устройствах. Вы можете открыть проект на смартфоне или планшете и работать с задачами в любом месте.' },
            ].map((faq, i) => (
              <div key={i} className="bg-[#FAFAFA] border border-[#EAEAEA] rounded-2xl p-6 sm:p-8">
                <button onClick={() => toggleFaq(i)} className="w-full flex items-center justify-between text-left cursor-pointer">
                  <h3 className="text-base sm:text-lg font-semibold text-[#1A1D21] pr-4">{faq.q}</h3>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-xl text-[#2ED596] transition-transform duration-300`}></i>
                  </div>
                </button>
                {openFaq === i && (
                  <p className="text-[14px] text-[#6B7280] leading-[1.7] mt-4 sm:mt-5">{faq.a}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="px-5 sm:px-6 py-16 sm:py-[80px] lg:py-[100px] bg-white">
        <div className="max-w-[1280px] mx-auto">
          <div className="bg-gradient-to-br from-[#1A1D21] via-[#252830] to-[#2E3039] rounded-[20px] sm:rounded-[28px] py-14 sm:py-[70px] lg:py-[90px] px-5 sm:px-6 text-center relative overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(46,213,150,0.1),transparent_60%)]"></div>
            <div className="relative z-10">
              <h2 className="text-[26px] sm:text-[36px] lg:text-[44px] font-bold text-white mb-4 sm:mb-5 tracking-tight px-2">Начните управлять проектами по-новому</h2>
              <p className="text-sm sm:text-base lg:text-lg text-white/60 mb-8 sm:mb-10 max-w-[560px] mx-auto px-2">Попробуйте PITIP бесплатно и убедитесь, насколько гибким может быть управление задачами</p>
              <button className="bg-[#2ED596] text-[#1A1D21] text-[15px] px-8 sm:px-12 py-3.5 sm:py-4 rounded-xl font-semibold shadow-[0_8px_24px_rgba(46,213,150,0.25)] hover:bg-[#3BE0A3] hover:shadow-[0_12px_32px_rgba(46,213,150,0.35)] hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">Создать первый проект</button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#F0F0F0] py-12 sm:py-16 lg:py-20 px-5 sm:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row lg:justify-between gap-10 lg:gap-0 mb-10 sm:mb-[60px]">
            <div className="max-w-[300px]">
              <div className="flex items-center gap-2.5 mb-4">
                <img src="https://static.readdy.ai/image/a7bae0ab6e910543915ac404c3477688/68a994a495d65f03a0ceb04460b10eaa.png" alt="PITIP Logo" className="w-9 h-9 object-contain" />
                <h3 className="text-[22px] sm:text-[26px] font-bold text-[#1A1D21]">PITIP</h3>
              </div>
              <p className="text-[13px] sm:text-[14px] text-[#6B7280] leading-[1.7]">Гибкая веб-платформа для управления проектами и задачами с кастомными полями и мощными инструментами организации</p>
            </div>

            <div className="grid grid-cols-3 gap-8 sm:gap-12 lg:gap-20">
              <div>
                <h4 className="text-[11px] uppercase text-[#6B7280] mb-3 sm:mb-4 font-semibold tracking-wider"><a href="#features">Продукт</a></h4>
                <ul className="space-y-2.5 sm:space-y-3">
                  <li><a href="#features" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Возможности</a></li>
                  <li><a href="#pricing" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Цены</a></li>
                  <li><a href="#" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Обновления</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-[11px] uppercase text-[#6B7280] mb-3 sm:mb-4 font-semibold tracking-wider">Компания</h4>
                <ul className="space-y-2.5 sm:space-y-3">
                  <li><a href="#" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">О нас</a></li>
                  <li><a href="#" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Блог</a></li>
                  <li><a href="#" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Контакты</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-[11px] uppercase text-[#6B7280] mb-3 sm:mb-4 font-semibold tracking-wider">Поддержка</h4>
                <ul className="space-y-2.5 sm:space-y-3">
                  <li><a href="#" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Документация</a></li>
                  <li><a href="#" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Помощь</a></li>
                  <li><a href="#" className="text-[13px] sm:text-[14px] text-[#4B5563] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Статус</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-[#D4D4D4] pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-[12px] sm:text-sm text-[#6B7280] text-center sm:text-left">
              © 2025 PITIP. Все права защищены.{' '}
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer">Powered by Readdy</a>
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-[#6B7280] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer"><i className="ri-twitter-x-line text-lg"></i></a>
              <a href="#" className="text-[#6B7280] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer"><i className="ri-github-line text-lg"></i></a>
              <a href="#" className="text-[#6B7280] hover:text-[#1A1D21] transition-colors duration-300 cursor-pointer"><i className="ri-linkedin-line text-lg"></i></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
